import type { SubAppModuleFederation } from '@ucc/admin-module-federation-utils'

import appConfig, { AppConfig } from 'config/appConfig'
import authConfig, { AuthConfig } from 'config/authConfig'
import { version } from 'config/version'
import { getEnvironment } from './getEnvironment'
import productsConfig, { ProductsConfig } from './productsConfig'
import subAppsModuleFederationConfig from './subAppsModuleFederationConfig'

export const environment = getEnvironment(window.location.hostname)

interface Config extends AppConfig, AuthConfig, ProductsConfig {
  ENV: string
  IS_TEST_ENV: boolean
  version: string
  APP_URL_PREFIX: string
  subAppsModuleFederation: { [key in string]: SubAppModuleFederation }
  sentryDsn: string
}

export const config: Config = {
  ...authConfig[environment],
  ...appConfig[environment],
  subAppsModuleFederation: {
    ...subAppsModuleFederationConfig[environment],
  },
  ...productsConfig[environment],
  APP_URL_PREFIX: '/', //new URL(document.baseURI).pathname.replace(/\/$/, ''),
  ENV: environment,
  IS_TEST_ENV: navigator.userAgent === 'chromium-e2e',
  version,
  sentryDsn: 'https://9a10223c7cb346b1946300862ece370f@o173976.ingest.us.sentry.io/5678187',
}

export default config
